define('constants/signupEmailVerificationConstants',[], function() {
    return {
        MaxVerificationCodeSendCount: 5,
        MaxVerificationAttempts: 10
    };
});
